import React, { useContext, useEffect, useState } from 'react'
import plus from '../dist/webImages/plus.svg'
import { Link } from 'react-router-dom';
import useGet from '../customHooks/useGet';
import { MainLanguageContext } from '../context/MainLanguageContext';
import usePost from '../customHooks/usePost';
import { Pagination } from 'antd';
import SkeletonProductsCard from './SkeletonProductsCard';
import ProductsCard from './ProductsCard';

const ProductsMain = ({permission}) => {
    const { mainLanguage } = useContext(MainLanguageContext);
    const [datas, setDatas] = useState()
    const [resget, apiMethodGet] = useGet()
    const [currentPage, setCurrentPage] = useState(1)
    const [paginationn, setPaginationn] = useState(12);
    const [searchValue, setSearchValue] = useState("")
    const [stockStatus, setStockStatus] = useState("")
    const [res2, apiMethod2] = usePost()

    const buildSearchPayload = (value = searchValue, status = stockStatus) => {
        let formdata = new FormData();
        formdata.append('search_query', value);
        if (status !== "") {
            formdata.append('stock_status', status);
        }
        return formdata;
    };

    const fetchProducts = (page = currentPage, value = searchValue, status = stockStatus) => {
        const trimmedValue = (value ?? "").trim();
        const hasStockFilter = status !== "";
        const formdata = buildSearchPayload(value, status);

        if (trimmedValue || hasStockFilter) {
            apiMethod2(`products/search_products_list/${mainLanguage}/12?page=${page}`, formdata);
        } else {
            apiMethodGet(`products/list/${mainLanguage}/12?page=${page}`, formdata);
        }
    };

    const onChange = (current, pageSize) => {
        setCurrentPage(current)
        fetchProducts(current, searchValue, stockStatus);
    };

    useEffect(() => {
        if (mainLanguage) {
            setCurrentPage(1)
            setSearchValue("")
            setStockStatus("")
            apiMethodGet(`products/list/${mainLanguage}/12?page=1`);
        }
    }, [mainLanguage]);

    let debounceTimer;
    const debounce = (func, delay) => {
        return (...args) => {
          clearTimeout(debounceTimer);
          debounceTimer = setTimeout(() => {
            func(...args);
          }, delay);
        };
      };

      const executeApiCall = (e) => {
        const nextValue = e.target.value;
        setSearchValue(nextValue)
        fetchProducts(currentPage, nextValue, stockStatus);
      };
      const handleChange = debounce(executeApiCall, 1000)

      const handleStockChange = (value) => {
        setStockStatus(value);
        setCurrentPage(1);
        fetchProducts(1, searchValue, value);
      };

    useEffect(() => {
        if (!resget.isLoading) {
            setDatas(resget?.data?.data)
            setPaginationn(resget.data?.pagination)
        }

    }, [resget.data])

    useEffect(() => {
        setDatas([])
        if (res2.data) {
            setDatas(res2?.data?.data);
            setPaginationn(res2?.data?.pagination)
        }
    }, [res2.data]);

 const check = (module, action) => permission?.[module]?.includes(action);
    return (
        <div className='NewsPage pr-10 max-lg:pr-6'>
            <div className="TeamPageTop flex justify-between items-center max-lg:flex-col max-lg:items-start gap-4">
                <h6 className='text-[1rem] mb-2 bookingSectionh relative px-3 font-Mluvka capitalize'>Products and updates</h6>
                <div className='flex flex-col items-end gap-3 w-full max-w-[52rem] max-lg:max-w-full'>
                  
                    <div className='flex items-center justify-end gap-4 flex-wrap w-full max-lg:justify-start'>
                        <div className='flex items-center gap-3 bg-white px-4 py-2 rounded-full border border-[#ddd] flex-wrap max-lg:rounded-2xl max-lg:items-start max-lg:flex-col'>
                            <span className='font-MluvkaBold text-secondary whitespace-nowrap'>Stock Status:</span>
                            <label className='flex items-center gap-2 cursor-pointer whitespace-nowrap'>
                                <input
                                    type='radio'
                                    className='relative top-[4px] mr-1'
                                    name='stock_status'
                                    value='1'
                                    checked={stockStatus === '1'}
                                    onChange={(e) => handleStockChange(e.target.value)}
                                />
                                <span className='text-sm'>In Stock</span>
                            </label>
                            <label className='flex items-center gap-2 cursor-pointer whitespace-nowrap'>
                                <input
                                    type='radio'
                                    className='relative top-[4px] mr-1'
                                    name='stock_status'
                                    value='0'
                                    checked={stockStatus === '0'}
                                    onChange={(e) => handleStockChange(e.target.value)}
                                />
                                <span className='text-sm'>Out of Stock</span>
                            </label>
                        </div>
                        {check("Products", "Products View") && <Link to={"/products/bulk-update-prices"} className='rounded-full border border-[#D4DEF1] bg-white px-5 py-3 font-MluvkaBold text-primary'>
                            Bulk Update Prices
                        </Link>}
                        {check("Products", "Products Add") && <Link to={"/products/create"} className='bg-[#d9dcf8] py-3 px-6 rounded-full flex items-center gap-2 cursor-pointer'>
                            <img src={plus} alt="plus" style={{ filter: "brightness(100)" }} />
                            <span className='font-MluvkaBold text-white capitalize'>Add Products</span>
                        </Link>}
                    </div>
                      <div className="inputBox w-full">
                        <input
                          type="text"
                          onChange={handleChange}
                          className='w-full border h-[2.8rem] rounded-full px-5 border-[#ddd] outline-none'
                          placeholder='Search by Car Name, Model, Year Or Slug ...'
                        />
                    </div>
                </div>
            </div>
            <div className="NewsPageGrid mt-4 bg-[#EFF4FD] rounded-3xl p-6 grid grid-cols-3 gap-3 max-lg:grid-cols-1 max-lg:p-3">
            {resget.isLoading ? 
                         Array.from({ length: 12 }).map((_, index) => (
                            <React.Fragment key={index}>
                            <SkeletonProductsCard  />
                        </React.Fragment>
                         ))
                        :
                        Array.isArray(datas) && datas.map((item, index) => {
                            return (
                                <React.Fragment key={index}>
                                    <ProductsCard permission={permission} data={item} alldata={datas} deleted={setDatas}  />
                                </React.Fragment>
                            )
                        })}
            </div>
            <div className='my-4'>
                <Pagination
                    onChange={onChange}
                    defaultCurrent={currentPage}
                    total={paginationn?.total}
                    pageSize={12}
                    showSizeChanger={true}
                />
            </div>
        </div>
    )
}

export default ProductsMain
